export default (props, { mediaQuery, rhythm }) => {
  return {
    root: {
      textAlign: 'center'
    },
    form: {
      maxWidth: rhythm(12.5),
      margin: '1rem auto 0',
      justifyContent: 'center',
      '& > *': {
        margin: rhythm(0.25)
      },
      [mediaQuery('sm')]: {
        display: 'flex'
      }
    },
    buttons: {
      maxWidth: rhythm(12),
      margin: `0 auto ${rhythm(1)}`,
      '& > :first-child': {
        marginBottom: rhythm(0.5)
      }
    }
  }
}
